import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@Component({
  selector: 'app-countdown-limit',
  standalone: true,
  imports: [CommonModule, PipesModule],
  templateUrl: './countdown-limit.component.html',
  styleUrls: ['./countdown-limit.component.scss'],
})
export class CountdownLimitComponent implements OnInit, OnDestroy {
  @Input() until: number = 0; // Unix timestamp in seconds
  @Input() showDays: boolean = true;
  @Output() countdownComplete = new EventEmitter<void>();

  countdown = { days: '00', hours: '00', minutes: '00', seconds: '00' };
  private countdownInterval: any;
  private isFetchingLimit = false;

  ngOnInit() {
    if (this.until) {
      this.startCountdown();
    }
  }

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  startCountdown() {
    this.updateCountdown();
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    const now = moment();
    const end = moment(this.until * 1000);
    const duration = moment.duration(end.diff(now));

    const days = Math.max(0, Math.floor(duration.asDays()));
    const hours = Math.max(0, duration.hours());
    const minutes = Math.max(0, duration.minutes());
    const seconds = Math.max(0, duration.seconds());

    this.countdown = {
      days: days.toString().padStart(2, '0'),
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0'),
    };

    if (days === 0 && hours === 0 && minutes === 0 && seconds === 0 && !this.isFetchingLimit) {
      this.isFetchingLimit = true;
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      const timeout = setTimeout(() => {
        this.countdownComplete.emit();
        this.isFetchingLimit = false;
        clearTimeout(timeout);
      }, 1000);
    }
  }
}
